import { Injectable } from '@angular/core';
import * as AWS from 'aws-sdk/global';
import * as S3 from 'aws-sdk/clients/s3';
import { getLocaleCurrencyName } from '@angular/common';
import { fileURLToPath } from 'url'; 

@Injectable({
  providedIn: 'root'
})
export class UpserviceService {

  constructor() { }

  public objectKey;
  public proposalKey; 

  /**
   * Used to upload profile picture into S3 bucket.
  */
  uploadFile(file, sub, prop_id) {

    // console.log ("objectKey: ",this.objectKey);

    const contentType = file.type;

    var filePath = `Property Owners/${sub}/${prop_id}/`

    const bucket = new S3(
      {
        accessKeyId: 'AKIAJZQQRWA5MTFVYY4A',
        secretAccessKey: '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',
      }
    );
    const params = {
      Bucket: 'ganisponsormarket-all-purpose',
      Key: filePath + file.name,
      Body: file,
      ACL: 'public-read',
      ContentType: contentType
    };

    // Uploading the file into S3 bucket
    bucket.upload(params, function (err, data) {

      if (err) {
        console.log('There was an error uploading your file: ', err);
        return err;
      }
      console.log('Successfully uploaded file.', data);
      console.log("This is the Location Key " + data.Location);

      return data;
    });

  }

  uploadFileToS3(file, sub, prop_id) {
    const contentType = file.type;
    var filePath = `Property Owners/${sub}/${prop_id}/`; 
    // var filePath2 = `Property Owners/${sub}/${prop_id}/`; 

    const bucket = new S3({
      accessKeyId: 'AKIAJZQQRWA5MTFVYY4A',
      secretAccessKey: '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',
    });

    const params = {
      Bucket: 'ganisponsormarket-all-purpose',
      Key: filePath + file.name,
      Body: file,
      ACL: 'public-read',
      ContentType: contentType
    }

    bucket.upload(params, function (err, data) { 
      if (err) {
        // return 'Failed to Upload'; 
        return 'failed to upload';
      }
      else {
        // return 'Successful Upload'; 
        console.log('Data ::: ', data); 
        this.proposalKey = data.Location; 
        console.log('Proposal Location ::: ', this.proposalKey)

      }
    })
  }

  public getLocaltionKey() {
    return this.objectKey;
  }

  public getProposalKey() {
    return this.proposalKey; 
  }
}
